import '../../App.css';
import React, { useContext, useEffect, useState, useRef } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { FaTimes, FaPlus, FaImage, } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import SelectMultiplo, { paraOpcoes, comoEvento } from '../SelectMultiplo';
import moment from 'moment';
import LoadingScreen from '../LoadingScreen';

function ModalEditarServico({ currentPage }) {
    const { EditarServico, EdicaoServico, setEdicaoServico, setModalEditarServico, ListaGrupo, Grupos, ServicoSubgrupo, RetornaSubgrupo, ServicoItem, RetornaItem, ListaTipoServico, TiposServico, ListaSLA, SLAs, ListaPeriodicidade, Periodicidades, ListaCobertura, Coberturas, AdicionarAnexoServico, setAddFileServico, ExcluirAnexoServico, ListaAnexoServico, FileServico, BaixarAnexoServico, ListaLink, Link, setAddLink, AdicionarLink, ExcluirLink, linkRef, descricaoRef, ListaOrganizacaoServico, ServicoOrganizacao, ListaAreaServico, ServicoArea, Organizacoes, ListaOrganizacao, Praticas, ListaPratica, ListaPraticaServico, ServicoPratica, ListaFornecedor, Fornecedores, ListaFornecedorServico, ServicoFornecedor, RetornaLocalidade, ServicoLocalidade, setServicoLocalidade, ListaLocalidadeServico, ServicoLocalidadeEditar, ListaMetodo, Metodos, ServicoAtualKey, ListaSistemaServico, ServicoSistema, AdicionarSistemaServico, ExcluirSistemaServico, setError, Loading, setLoading, ListaAreaDisponivel, AreaServicoDisponivel, ListaExecutorServico, ServicoExecutor } = useContext(ServicoContext)
    const { Permissao, ListaCargo, Cargos, ListaSistemas, Sistemas, ListaLinhaAtendimento, Linhas } = useContext(ApiContext)
    const { btnVer, btnCriar, btnPesquisar } = useContext(StyleContext)
    const anexoRef = useRef()
    const sistemaRef = useRef()

    const [grupoKey, setGrupoKey] = useState(EdicaoServico?.grupo?.key || "")
    const [subGrupoKey, setSubGrupoKey] = useState(EdicaoServico?.subGrupo?.key || "")
    const [itemKey, setItemKey] = useState(EdicaoServico?.item?.key || "")
    const [slaAtendimentoKey, setSlaAtendimentoKey] = useState(EdicaoServico?.slaAtendimento?.key || "")
    const [cargoDonoKey, setCargoDonoKey] = useState(EdicaoServico?.cargoDono?.key || "")
    const [tipoServicoKey, setTipoServicoKey] = useState(EdicaoServico?.tipoServico?.key || "")
    const [slaSolucaoKey, setSlaSolucaoKey] = useState(EdicaoServico?.slaSolucao?.key || "")
    const [periodicidadeKey, setPeriodicidadeKey] = useState(EdicaoServico?.periodicidade?.key || "")
    const [coberturaKey, setCoberturaKey] = useState(EdicaoServico?.cobertura?.key || "")
    const [metodoSolicitacaoKey, setMetodoSolicitacaoKey] = useState(EdicaoServico?.metodoSolicitacao?.key || "");
    const [organizacoesSelecionadas, setOrganizacoesSelecionadas] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);
    const [praticasSelecionadas, setPraticasSelecionadas] = useState([]);
    const [executoresSelecionados, setExecutoresSelecionados] = useState([]);
    const [fornecedoresSelecionados, setFornecedoresSelecionados] = useState([]);
    const [localidadesSelecionadas, setLocalidadesSelecionadas] = useState([]);
    const [organizacaoKey, setOrganizacaoKey] = useState([])
    const [sistemaKey, setSistemaKey] = useState("")
    const [organizacoesCarregadas, setOrganizacoesCarregadas] = useState(false);
    const [localidadesCarregadas, setLocalidadesCarregadas] = useState(false);
    const [areasCarregadas, setAreasCarregadas] = useState(false);
    const [praticasCarregadas, setPraticasCarregadas] = useState(false);
    const [executoresCarregados, setExecutoresCarregados] = useState(false);
    const [fornecedoresCarregados, setFornecedoresCarregados] = useState(false);
    const [localidadesHidratadas, setLocalidadesHidratadas] = useState(false);

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoServico.descricao) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarServico(grupoKey, subGrupoKey, itemKey, cargoDonoKey, tipoServicoKey, slaAtendimentoKey, slaSolucaoKey, periodicidadeKey, coberturaKey, metodoSolicitacaoKey, currentPage)
            .then(() => {
                setModalEditarServico(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const adicionarAnexo = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setAddFileServico(file);
    };

    const addAnexo = () => {
        AdicionarAnexoServico()
            .then(() => {
                setAddFileServico(null)
                anexoRef.current.value = ""
            })
    }

    const adicionarLink = (event) => {
        const { name, value } = event.target;
        setAddLink((prevAddLink) => ({
            ...prevAddLink,
            [name]: value
        }));
    }

    const handleChange = (event) => {
        setEdicaoServico({ ...EdicaoServico, [event.target.name]: event.target.value })
    }

    const chamarLista = async () => {
        ListaGrupo()
        ListaCargo()
        ListaTipoServico()
        ListaSLA()
        ListaPeriodicidade()
        ListaCobertura()
        ListaOrganizacao()
        ListaAreaDisponivel()
        ListaPratica()
        ListaFornecedor()
        ListaMetodo()
        ListaSistemas()
        ListaLink();
        ListaAnexoServico();
        ListaOrganizacaoServico();
        ListaAreaServico();
        ListaPraticaServico();
        ListaFornecedorServico();
        ListaLocalidadeServico();
        ListaSistemaServico();
        ListaExecutorServico();
        ListaLinhaAtendimento('S')
    }

    useEffect(() => {
        setLoading(true);
        chamarLista().then(() => {
            setLoading(false)
        })
    }, [])

    const handleGrupoChange = (e) => {
        const value = e.target.value;
        setGrupoKey(value);
        setSubGrupoKey("");
        setItemKey("");
    };

    const handleSubGrupoChange = (e) => {
        const value = e.target.value;
        setSubGrupoKey(value);
        setItemKey("");
    };

    const handleItemChange = (e) => {
        const value = e.target.value;
        setItemKey(value);
    };

    useEffect(() => {
        if (grupoKey) {
            RetornaSubgrupo(grupoKey);
        }
    }, [grupoKey]);

    useEffect(() => {
        if (subGrupoKey) {
            RetornaItem(subGrupoKey);
        }
    }, [subGrupoKey]);

    useEffect(() => {
        if (!ServicoOrganizacao || !Organizacoes?.length) return;

        const selecionadas = ServicoOrganizacao
            .map(item => item.organizacao?.key)
            .filter(Boolean);

        setOrganizacoesSelecionadas(selecionadas);

        setEdicaoServico(prev => ({
            ...prev,
            organizacoes: selecionadas.map(key => ({
                organizacaoKey: key,
                servicoKey: ServicoAtualKey,
            })),
        }));

        setOrganizacoesCarregadas(true);
    }, [ServicoOrganizacao, Organizacoes]);


    useEffect(() => {
        const dadosCarregados = ServicoArea !== undefined && AreaServicoDisponivel && AreaServicoDisponivel.length > 0;

        if (dadosCarregados) {
            if (ServicoArea.length > 0) {
                const selecionadas = ServicoArea.map(item =>
                    AreaServicoDisponivel.find(org => org.key === item.area.key)
                ).filter(Boolean);

                setAreasSelecionadas(selecionadas.map(item => item.key));

                const novasAreas = ServicoArea.map(item => ({
                    areaKey: item?.area?.key,
                    servicoKey: ServicoAtualKey,
                }));

                setEdicaoServico(prev => ({
                    ...prev,
                    areas: novasAreas,
                }));
            } else {
                setAreasSelecionadas([]);

                setEdicaoServico(prev => ({
                    ...prev,
                    areas: [],
                }));
            }

            setAreasCarregadas(true);
        }
    }, [ServicoArea, AreaServicoDisponivel]);

    useEffect(() => {
        const dadosCarregados = ServicoPratica !== undefined && Praticas && Praticas.length > 0;

        if (dadosCarregados) {
            if (ServicoPratica.length > 0) {
                const selecionadas = ServicoPratica.map(item =>
                    Praticas.find(org => org?.key === item?.praticasReferencia?.key)
                ).filter(Boolean);

                setPraticasSelecionadas(selecionadas.map(item => item.key));

                const novasPraticas = ServicoPratica.map(item => ({
                    praticaReferenciaKey: item?.praticasReferencia?.key,
                    servicoKey: ServicoAtualKey,
                }));

                setEdicaoServico(prev => ({
                    ...prev,
                    praticas: novasPraticas,
                }));
            } else {
                setPraticasSelecionadas([]);

                setEdicaoServico(prev => ({
                    ...prev,
                    praticas: [],
                }));
            }

            setPraticasCarregadas(true);
        }
    }, [ServicoPratica, Praticas]);

    useEffect(() => {
        const dadosCarregados = ServicoFornecedor !== undefined && Fornecedores && Fornecedores.length > 0;

        if (dadosCarregados) {
            if (ServicoFornecedor.length > 0) {
                const selecionadas = ServicoFornecedor.map(item =>
                    Fornecedores.find(org => org?.key === item?.fornecedor?.key)
                ).filter(Boolean);
                setFornecedoresSelecionados(selecionadas.map(item => item.key));

                const novosFornecedores = ServicoFornecedor.map((item) => ({
                    fornecedorKey: item?.fornecedor?.key,
                    servicoKey: ServicoAtualKey,
                }));

                setEdicaoServico((prev) => ({
                    ...prev,
                    fornecedores: novosFornecedores,
                }));
            } else {
                setFornecedoresSelecionados([]);
            }

            setFornecedoresCarregados(true);
        }
    }, [ServicoFornecedor, Fornecedores]);

     useEffect(() => {
        const dadosCarregados = ServicoExecutor !== undefined && Linhas && Linhas.length > 0;

        if (dadosCarregados) {
            if (ServicoExecutor.length > 0) {
                const selecionadas = ServicoExecutor.map(item =>
                    Linhas.find(org => org?.key === item?.linhaAtendimentoExecutor?.key)
                ).filter(Boolean);

                setExecutoresSelecionados(selecionadas.map(item => item.key));

                const novosExecutores = ServicoExecutor.map((item) => ({
                    linhaAtendimentoKey: item?.linhaAtendimentoKey
                        ?? item?.linhaAtendimentoExecutor?.key,
                    servicoKey: ServicoAtualKey,
                }));

                setEdicaoServico(prev => ({
                    ...prev,
                    linhasExecutores: novosExecutores,
                }));
            } else {
                setExecutoresSelecionados([]);

                setEdicaoServico(prev => ({
                    ...prev,
                    linhasExecutores: [],
                }));
            }

            setExecutoresCarregados(true);
        }
    }, [ServicoExecutor, Linhas]);

    useEffect(() => {
        if (
            localidadesHidratadas ||                       // 🔒 só uma vez
            organizacoesSelecionadas.length === 0 ||
            !Array.isArray(ServicoLocalidadeEditar) ||
            !Array.isArray(ServicoLocalidade) ||
            ServicoLocalidade.length === 0
        ) {
            return;
        }

        if (ServicoLocalidadeEditar.length > 0) {
            const selecionadas = ServicoLocalidadeEditar
                .map(item =>
                    ServicoLocalidade.find(loc => loc.key === item.localidade?.key)
                )
                .filter(Boolean);

            const keys = selecionadas.map(item => item.key);

            setLocalidadesSelecionadas(keys);

            setEdicaoServico(prev => ({
                ...prev,
                localidades: keys.map(key => ({
                    localidadeKey: key,
                    servicoKey: ServicoAtualKey,
                })),
            }));
        }

        setLocalidadesHidratadas(true);   // ✅ trava o efeito
    }, [
        organizacoesSelecionadas,
        ServicoLocalidadeEditar,
        ServicoLocalidade,
        localidadesHidratadas
    ]);

    const adicionarSistema = () => {
        if (!sistemaKey || sistemaKey === "0") {
            setError("Selecione uma aplicação.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        AdicionarSistemaServico(sistemaKey)
            .then(() => {
                setSistemaKey("");
                sistemaRef.current.value = 0;
            });
    };

    useEffect(() => {
        setLocalidadesHidratadas(false);   // 🔓 permite nova hidratação
        setLocalidadesSelecionadas([]);

        setEdicaoServico(prev => ({
            ...prev,
            localidades: [],
        }));

        if (organizacoesSelecionadas.length > 0) {
            RetornaLocalidade(organizacoesSelecionadas);
        } else {
            setServicoLocalidade([]);
        }
    }, [organizacoesSelecionadas]);

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar serviço</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarServico(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Tabs className='mt-3 mb-3'>
                            <Tab eventKey="geral" title={<span>Geral</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <Form.Control maxLength={255} value={EdicaoServico.descricao} onChange={handleChange} name="descricao" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Grupo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={grupoKey} onChange={handleGrupoChange} name="grupoKey">
                                                <option value="">Selecione</option>
                                                {Grupos && Grupos.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.grupo?.key ? true : false}>
                                                            {item.descricao}
                                                        </option>
                                                    )
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Subgrupo</Form.Label>
                                            <Form.Select aria-label="Default select example" value={subGrupoKey} onChange={handleSubGrupoChange} name="subGrupoKey">
                                                <option value="">Selecione</option>
                                                {ServicoSubgrupo &&
                                                    ServicoSubgrupo.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.subGrupo?.key ? true : false}>{item.descricao}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Item</Form.Label>
                                            <Form.Select aria-label="Default select example" value={itemKey} onChange={handleItemChange} name="itemKey">
                                                <option value="">Selecione</option>
                                                {ServicoItem &&
                                                    ServicoItem.sort((a, b) => a?.descricao?.localeCompare(b?.descricao))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.item?.key ? true : false}>{item.descricao}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Dono do Serviço</Form.Label>
                                            <Form.Select aria-label="Default select example" value={cargoDonoKey} onChange={(e) => setCargoDonoKey(e.target.value)} name="cargoDonoKey">
                                                <option value="">Selecione</option>
                                                {Cargos &&
                                                    Cargos.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={item.key == EdicaoServico?.cargoDono?.key ? true : false}>{item.descricao}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Executor do Serviço</Form.Label>
                                            {executoresCarregados ?
                                                <SelectMultiplo
                                                    className='input-width'
                                                    options={paraOpcoes(Linhas, 'key', 'nome')}
                                                    value={executoresSelecionados}
                                                    onChange={comoEvento((e) => {
                                                        const values = e.target.value || [];
                                                        setExecutoresSelecionados(values);

                                                        const novosExecutores = values.map((key) => ({
                                                            linhaAtendimentoKey: key,
                                                            servicoKey: ServicoAtualKey,
                                                        }));

                                                        setEdicaoServico((prev) => ({
                                                            ...prev,
                                                            linhasExecutores: novosExecutores,
                                                        }));
                                                    })}
                                                />
                                                :
                                                <LoadingScreen />
                                            }
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tipo do Serviço</Form.Label>
                                            <Form.Select aria-label="Default select example" value={tipoServicoKey} onChange={(e) => setTipoServicoKey(e.target.value)} name="tipoServicoKey">
                                                <option value="">Selecione</option>
                                                {TiposServico &&
                                                    TiposServico.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.tipoServico?.key ? true : false}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Empresas Atendidas</Form.Label>
                                            {organizacoesCarregadas ?
                                                <SelectMultiplo
                                                    className='input-width'
                                                    options={paraOpcoes(Organizacoes, 'key', 'nome')}
                                                    value={organizacoesSelecionadas}
                                                    onChange={comoEvento((e) => {
                                                        const values = e.target.value || [];
                                                        setOrganizacoesSelecionadas(values);

                                                        const novasOrganizacoes = values.map(key => ({
                                                            organizacaoKey: key,
                                                            servicoKey: ServicoAtualKey,
                                                        }));

                                                        setEdicaoServico((prev) => ({
                                                            ...prev,
                                                            organizacoes: novasOrganizacoes,
                                                        }));
                                                    })}
                                                />
                                                :
                                                <LoadingScreen />
                                            }
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Local de Execução</Form.Label>
                                            {/* {localidadesCarregadas ? */}
                                            <SelectMultiplo
                                                className='input-width'
                                                options={paraOpcoes(ServicoLocalidade, 'key', 'nome')}
                                                value={localidadesSelecionadas}
                                                onChange={comoEvento((e) => {
                                                    const values = e.target.value || [];
                                                    setLocalidadesSelecionadas(values);

                                                    const novasLocalidades = values.map((key) => ({
                                                        localidadeKey: key,
                                                        servicoKey: ServicoAtualKey,
                                                    }));

                                                    setEdicaoServico((prev) => ({
                                                        ...prev,
                                                        localidades: novasLocalidades,
                                                    }));
                                                })}
                                            />
                                            {/* :
                                                <LoadingScreen />
                                            } */}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Área Solicitante</Form.Label>
                                            {areasCarregadas ?
                                                <SelectMultiplo
                                                    className='input-width'
                                                    options={paraOpcoes(AreaServicoDisponivel, 'key', 'descricao')}
                                                    value={areasSelecionadas}
                                                    onChange={comoEvento((e) => {
                                                        const values = e.target.value || [];
                                                        setAreasSelecionadas(values);

                                                        const novasAreas = values.map((key) => ({
                                                            areaKey: key,
                                                            servicoKey: ServicoAtualKey,
                                                        }));

                                                        setEdicaoServico((prev) => ({
                                                            ...prev,
                                                            areas: novasAreas,
                                                        }));
                                                    })}
                                                />
                                                :
                                                <LoadingScreen />
                                            }
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Método Solicitação</Form.Label>
                                            <Form.Select aria-label="Default select example" value={metodoSolicitacaoKey} onChange={(e) => setMetodoSolicitacaoKey(e.target.value)} name="metodoSolicitacaoKey">
                                                <option value="">Selecione</option>
                                                {Metodos &&
                                                    Metodos.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.metodoSolicitacao?.key ? true : false}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="nivel" title={<span>Nível de Serviço</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opção</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Atendimento</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" value={slaAtendimentoKey} onChange={(e) => setSlaAtendimentoKey(e.target.value)} name="slaAtendimentoKey">
                                                <option value="">Selecione</option>
                                                {SLAs &&
                                                    SLAs.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.slaAtendimento?.key ? true : false}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SLA de Solução</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" value={slaSolucaoKey} onChange={(e) => setSlaSolucaoKey(e.target.value)} name="slaSolucaoKey">
                                                <option value="">Selecione</option>
                                                {SLAs &&
                                                    SLAs.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.slaSolucao?.key ? true : false}>{item.nome}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Periodicidade de Solicitação</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" value={periodicidadeKey} onChange={(e) => setPeriodicidadeKey(e.target.value)} name="periodicidadeKey">
                                                <option value="">Selecione</option>
                                                {Periodicidades &&
                                                    Periodicidades.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={item.key == EdicaoServico?.periodicidade?.key ? true : false}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Período de Cobertura</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Select aria-label="Default select example" value={coberturaKey} onChange={(e) => setCoberturaKey(e.target.value)} name="coberturaKey">
                                                <option value="">Selecione</option>
                                                {Coberturas &&
                                                    Coberturas.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item?.key} selected={item?.key == EdicaoServico?.cobertura?.key ? true : false}>{item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Práticas de Referência</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            {praticasCarregadas ?
                                                <SelectMultiplo
                                                    className='input-width'
                                                    options={paraOpcoes(Praticas, 'key', 'nome')}
                                                    value={praticasSelecionadas}
                                                    onChange={comoEvento((e) => {
                                                        const values = e.target.value || [];
                                                        setPraticasSelecionadas(values);

                                                        const novasPraticas = values.map((key) => ({
                                                            praticaReferenciaKey: key,
                                                            servicoKey: ServicoAtualKey,
                                                        }));

                                                        setEdicaoServico((prev) => ({
                                                            ...prev,
                                                            praticas: novasPraticas,
                                                        }));
                                                    })}
                                                />
                                                :
                                                <LoadingScreen />
                                            }
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Fornecedores</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            {fornecedoresCarregados ?
                                                <SelectMultiplo
                                                    className='input-width'
                                                    options={paraOpcoes(Fornecedores, 'key', 'fantasia')}
                                                    value={fornecedoresSelecionados}
                                                    onChange={comoEvento((e) => {
                                                        const values = e.target.value || [];
                                                        setFornecedoresSelecionados(values);

                                                        const novosFornecedores = values.map((key) => ({
                                                            fornecedorKey: key,
                                                            servicoKey: ServicoAtualKey,
                                                        }));

                                                        setEdicaoServico((prev) => ({
                                                            ...prev,
                                                            fornecedores: novosFornecedores,
                                                        }));
                                                    })}
                                                />
                                                :
                                                <LoadingScreen />
                                            }
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="obs" title={<span>Observações</span>}>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Objetivo do Serviço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} defaultValue={EdicaoServico.objetivo} name="objetivo" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Escopo do Serviço</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} defaultValue={EdicaoServico.escopo} name="escopo" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Exclusões</Form.Label>
                                            <Form.Control maxLength={255} onChange={handleChange} defaultValue={EdicaoServico.exclusoes} name="exclusoes" as="textarea" rows={3} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab>
                            <Tab eventKey="anexos" title={<span>Anexos</span>}>
                                <div style={{ maxHeight: '450px', overflow: 'auto' }}>
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Link</Form.Label>
                                            <Form.Control onChange={adicionarLink} maxLength={500} name="addLink" ref={linkRef} />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control as="textarea" rows={2} maxLength={500} onChange={adicionarLink} name="descricaoLink" ref={descricaoRef} />
                                        </Form.Group>
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => AdicionarLink()}><FaPlus style={{ marginRight: "5px" }} />Adicionar link</button>
                                        </div>
                                        Links adicionados
                                        <div className="secao-link">
                                            {Link?.map((item) => {
                                                return (
                                                    <div key={item.keyLink} className="content-comentario">
                                                        <div style={{ width: '40%' }}>
                                                            <div className="div-comentario">
                                                                <p className="p-title">Usuário: </p>
                                                                <span>{item.nome}</span>
                                                            </div>
                                                            {moment(item.dataHora).format('L')} às {moment(item.dataHora).format('LT')}
                                                        </div>
                                                        <div className="div-link">
                                                            <p className="p-title">Link: </p>
                                                            <p><a href={item.link} target="_blank">{item.link}</a></p>
                                                        </div>
                                                        <div className="div-comentario">
                                                            <p className="p-title">Comentário: </p>
                                                            <span><p >{item.descricao}</p></span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirLink(item.keyLink)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                    <hr />
                                    <div>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Anexo</Form.Label>
                                            <Form.Control type='file' onChange={adicionarAnexo} name="file" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt" ref={anexoRef} />
                                        </Form.Group>
                                        <div style={{ display: "flex", justifyContent: "flex-end" }} className="mb-3">
                                            <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => addAnexo()}><FaPlus style={{ marginRight: "5px" }} />Adicionar anexo</button>
                                        </div>
                                        <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', maxHeight: '300px', overflow: 'auto' }}>
                                            {FileServico && FileServico?.map((item, index) => {
                                                return (
                                                    <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', marginBottom: '10px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <FaImage style={{ fontSize: '40px' }} />
                                                            <span style={{ wordBreak: 'break-word' }}>{item.nomeArquivo}</span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-download" onClick={() => BaixarAnexoServico(item?.key)}><FiDownload /></button>
                                                            <button type="button" className="btn-del" onClick={() => ExcluirAnexoServico(item?.key)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="sistemas" title={<span>Aplicações</span>}>
                                <h1 className='h1-modal'>Aplicações</h1>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                    <Col>
                                        <Form.Group>
                                            <Form.Select ref={sistemaRef} aria-label="Default select example" onChange={(e) => setSistemaKey(e.target.value)}>
                                                <option value={0}>Selecione</option>
                                                {Sistemas &&
                                                    Sistemas?.map((c) => {
                                                        return (
                                                            <option key={c.id} value={c.key}>{c.nome}</option>
                                                        )

                                                    })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => adicionarSistema()}><FaPlus /></button>
                                </div>
                                <hr />
                                <Row>
                                    <div style={{ minHeight: '30vh', maxHeight: '40vh', overflowY: 'auto', width: '100%' }}>
                                        {ServicoSistema && ServicoSistema.map((item, index) => {
                                            return (
                                                <div key={index}>
                                                    <div key={index} className="content-comentario">
                                                        <div className="div-comentario">
                                                            <SlOptionsVertical style={{ marginRight: '15px' }} />
                                                            <span><div dangerouslySetInnerHTML={{ __html: item.sistema.nome }} /></span>
                                                        </div>
                                                        <div className="div-button">
                                                            <button type="button" className="btn-del" onClick={() => ExcluirSistemaServico(item?.key)}><TbTrash /></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Row>
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarServico(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "SERVICOS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarServico